export default __webpack_public_path__ + "static/char-s-09-jp-22dbf668d6500bf853efaa5223d81951.webp";